import {
  DyteMeeting,
  DytePermissionsMessage,
  DyteRecordingIndicator,
  registerAddons,
} from '@dytesdk/react-ui-kit'
import { useDyteClient } from '@dytesdk/react-web-core'
import ChatHostControl from '@dytesdk/ui-kit-addons/chat-host-control'
import CustomButton from '@dytesdk/ui-kit-addons/custom-controlbar-button'
import HandRaise from '@dytesdk/ui-kit-addons/hand-raise'
import VideoBackground from '@dytesdk/ui-kit-addons/video-background'
import DyteVideoBackgroundTransformer from '@dytesdk/video-background-transformer'
import { ApiService } from '@services/ApiService'
import { useEffect, useRef, useState } from 'react'

interface Props {
  token: string
  kawaconnVideoToken: string
}

const blurInActiveIcon =
  '<svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg" fill="#ffffff" stroke="#ffffff"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path fill="var(--ci-primary-color, #ffffff)" d="M256,16A240,240,0,0,0,86.294,425.705,240,240,0,0,0,425.706,86.294,238.432,238.432,0,0,0,256,16ZM403.078,403.078h0c-81.1,81.1-213.058,81.1-294.157,0s-81.1-213.057,0-294.156a208.238,208.238,0,0,1,294.157,0C484.177,190.021,484.177,321.979,403.078,403.078Z" class="ci-primary"></path> <path fill="var(--ci-primary-color, #ffffff)" d="M197.483,242.382a46.332,46.332,0,1,0-32.776-13.555A46.206,46.206,0,0,0,197.483,242.382ZM187.334,185.9a14.354,14.354,0,1,1,0,20.3A14.311,14.311,0,0,1,187.334,185.9Z" class="ci-primary"></path> <path fill="var(--ci-primary-color, #ffffff)" d="M314.517,242.382a46.344,46.344,0,1,0-32.777-79.109h0a46.332,46.332,0,0,0,32.777,79.108ZM304.367,185.9a14.354,14.354,0,1,1,0,20.3A14.371,14.371,0,0,1,304.367,185.9Z" class="ci-primary"></path> <path fill="var(--ci-primary-color, #ffffff)" d="M164.707,283.173a46.353,46.353,0,1,0,65.553,0A46.048,46.048,0,0,0,164.707,283.173ZM207.633,326.1a14.347,14.347,0,1,1,0-20.3A14.372,14.372,0,0,1,207.633,326.1Z" class="ci-primary"></path> <path fill="var(--ci-primary-color, #ffffff)" d="M281.74,283.173a46.354,46.354,0,1,0,65.553,0A46.406,46.406,0,0,0,281.74,283.173ZM324.666,326.1a14.354,14.354,0,1,1,4.2-10.15A14.372,14.372,0,0,1,324.666,326.1Z" class="ci-primary"></path> <circle cx="314.517" cy="98.5" r="29.637" fill="var(--ci-primary-color, #ffffff)" class="ci-primary" transform="rotate(-9.217 314.534 98.505)"></circle> <circle cx="197.483" cy="98.5" r="29.637" fill="var(--ci-primary-color, #ffffff)" class="ci-primary" transform="rotate(-9.217 197.493 98.505)"></circle> <circle cx="314.517" cy="413.5" r="29.637" fill="var(--ci-primary-color, #ffffff)" class="ci-primary" transform="rotate(-67.5 314.517 413.5)"></circle> <circle cx="197.483" cy="413.5" r="29.637" fill="var(--ci-primary-color, #ffffff)" class="ci-primary" transform="rotate(-67.5 197.483 413.5)"></circle> <circle cx="413.5" cy="314.517" r="29.637" fill="var(--ci-primary-color, #ffffff)" class="ci-primary" transform="rotate(-22.5 413.5 314.518)"></circle> <circle cx="413.5" cy="197.483" r="29.637" fill="var(--ci-primary-color, #ffffff)" class="ci-primary" transform="rotate(-58.283 413.496 197.483)"></circle> <circle cx="98.5" cy="314.517" r="29.637" fill="var(--ci-primary-color, #ffffff)" class="ci-primary"></circle> <circle cx="98.5" cy="197.483" r="29.637" fill="var(--ci-primary-color, #ffffff)" class="ci-primary"></circle> </g></svg>'
const blurActiveIcon =
  '<svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg" fill="#ffffff" stroke="#0000ff"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path fill="var(--ci-primary-color, #ffffff)" d="M256,16A240,240,0,0,0,86.294,425.705,240,240,0,0,0,425.706,86.294,238.432,238.432,0,0,0,256,16ZM403.078,403.078h0c-81.1,81.1-213.058,81.1-294.157,0s-81.1-213.057,0-294.156a208.238,208.238,0,0,1,294.157,0C484.177,190.021,484.177,321.979,403.078,403.078Z" class="ci-primary"></path> <path fill="var(--ci-primary-color, #ffffff)" d="M197.483,242.382a46.332,46.332,0,1,0-32.776-13.555A46.206,46.206,0,0,0,197.483,242.382ZM187.334,185.9a14.354,14.354,0,1,1,0,20.3A14.311,14.311,0,0,1,187.334,185.9Z" class="ci-primary"></path> <path fill="var(--ci-primary-color, #ffffff)" d="M314.517,242.382a46.344,46.344,0,1,0-32.777-79.109h0a46.332,46.332,0,0,0,32.777,79.108ZM304.367,185.9a14.354,14.354,0,1,1,0,20.3A14.371,14.371,0,0,1,304.367,185.9Z" class="ci-primary"></path> <path fill="var(--ci-primary-color, #ffffff)" d="M164.707,283.173a46.353,46.353,0,1,0,65.553,0A46.048,46.048,0,0,0,164.707,283.173ZM207.633,326.1a14.347,14.347,0,1,1,0-20.3A14.372,14.372,0,0,1,207.633,326.1Z" class="ci-primary"></path> <path fill="var(--ci-primary-color, #ffffff)" d="M281.74,283.173a46.354,46.354,0,1,0,65.553,0A46.406,46.406,0,0,0,281.74,283.173ZM324.666,326.1a14.354,14.354,0,1,1,4.2-10.15A14.372,14.372,0,0,1,324.666,326.1Z" class="ci-primary"></path> <circle cx="314.517" cy="98.5" r="29.637" fill="var(--ci-primary-color, #ffffff)" class="ci-primary" transform="rotate(-9.217 314.534 98.505)"></circle> <circle cx="197.483" cy="98.5" r="29.637" fill="var(--ci-primary-color, #ffffff)" class="ci-primary" transform="rotate(-9.217 197.493 98.505)"></circle> <circle cx="314.517" cy="413.5" r="29.637" fill="var(--ci-primary-color, #ffffff)" class="ci-primary" transform="rotate(-67.5 314.517 413.5)"></circle> <circle cx="197.483" cy="413.5" r="29.637" fill="var(--ci-primary-color, #ffffff)" class="ci-primary" transform="rotate(-67.5 197.483 413.5)"></circle> <circle cx="413.5" cy="314.517" r="29.637" fill="var(--ci-primary-color, #ffffff)" class="ci-primary" transform="rotate(-22.5 413.5 314.518)"></circle> <circle cx="413.5" cy="197.483" r="29.637" fill="var(--ci-primary-color, #ffffff)" class="ci-primary" transform="rotate(-58.283 413.496 197.483)"></circle> <circle cx="98.5" cy="314.517" r="29.637" fill="var(--ci-primary-color, #ffffff)" class="ci-primary"></circle> <circle cx="98.5" cy="197.483" r="29.637" fill="var(--ci-primary-color, #ffffff)" class="ci-primary"></circle> </g></svg>'

// Reference: https://dyte.io/blog/building-timed-meetings
const MaMinutesDuration = 120 // 120 minutes
const KawaconnMeeting = (props: Props) => {
  const [meeting, initMeeting] = useDyteClient(null)
  // const [meeting, setMeeting] = useState(null)
  const [meetingConfig, setMeetingConfig] = useState(null)
  const isBlurActive = useRef(false)

  const videoMiddleware = useRef(null)
  useEffect(() => {
    const searchParams = new URL(window.location.href).searchParams
    const authToken = props.token ?? searchParams.get('authToken')
    if (!authToken) {
      alert(
        "An authToken wasn't passed, please pass an authToken in the URL query to join a meeting."
      )
      return
    }

    initMeeting({
      authToken: authToken,
      defaults: {
        audio: false,
        video: false,
      },
    }).then(meeting => {
      setTimeout(async () => {
        const videoBackground = new VideoBackground({
          segmentationConfig: {
            pipeline: 'canvas2dCpu', // 'webgl2' | 'canvas2dCpu'
          },
          images: [
            'https://assets.dyte.io/backgrounds/bg-dyte-office.jpg',
            'https://assets.dyte.io/backgrounds/bg_0.jpg',
            'https://assets.dyte.io/backgrounds/bg_2.jpg',
            'https://assets.dyte.io/backgrounds/bg_3.jpg',
            'https://assets.dyte.io/backgrounds/bg_4.jpg',
            'https://assets.dyte.io/backgrounds/bg_5.jpg',
            'https://assets.dyte.io/backgrounds/bg_6.jpg',
            'https://assets.dyte.io/backgrounds/bg_7.jpg',
          ],
          modes: ['blur', 'virtual'],
        })

        const handRaise = await HandRaise.init({
          meeting,
          canRaiseHand: true,
          canManageRaisedHand: true,
          // handRaiseIcon: '<svg>...</svg>', // optional, Replace it with proper SVG
        })

        const chatHostControl = await ChatHostControl.init({
          meeting,
          hostPresets: ['webinar_presenter'],
          targetPresets: ['webinar_viewer'],
          addActionInParticipantMenu: true,
        })

        const customButton = new CustomButton({
          position: 'left', // left | center | right | more-menu
          label: 'Blur Background',
          onClick: async () => {
            if (!isBlurActive.current) {
              const videoBackgroundTransformer =
                await DyteVideoBackgroundTransformer.init({
                  meeting: meeting,
                  segmentationConfig: {
                    pipeline: 'canvas2dCpu', // 'webgl2' | 'canvas2dCpu'
                  },
                })

              videoMiddleware.current =
                await videoBackgroundTransformer.createBackgroundBlurVideoMiddleware(
                  50
                )
              meeting.self.addVideoMiddleware(videoMiddleware.current)
              isBlurActive.current = true
              customButton.update({
                icon: blurActiveIcon,
                label: 'Unblur Background',
              })
            } else {
              if (videoMiddleware.current) {
                meeting.self.removeVideoMiddleware(videoMiddleware.current)
              }
              customButton.update({
                icon: blurInActiveIcon,
                label: 'Blur Background',
              })
              isBlurActive.current = false
            }
          },
          icon: blurInActiveIcon,
        })
        const config = registerAddons(
          [videoBackground, handRaise, chatHostControl, customButton],
          meeting
        )
        setMeetingConfig(config)

        meeting.participants.joined.on('participantJoined', participant => {
          setTimeout(() => {
            ApiService.VideoMeeting.CloseMeeting(
              meeting.meta.meetingId,
              props.kawaconnVideoToken
            )
          }, MaMinutesDuration * 60 * 1000)
        })
      }, 500)
    })
  }, [])

  return (
    <>
      <DytePermissionsMessage meeting={meeting} />

      {meeting && meetingConfig && (
        <>
          <DyteRecordingIndicator
            title="Recording"
            color="blue"
            meeting={meeting}
          >
            Video is recorded
          </DyteRecordingIndicator>
          <DyteMeeting meeting={meeting} config={meetingConfig} />
        </>
      )}
    </>
  )
}

export default KawaconnMeeting
